import { jsx as r } from "react/jsx-runtime";
import { useCallback as s } from "react";
import { PermissionsContext as e } from "./hooks/usePermissionsContext.js";
const i = ({ children: i2, usePermissionsQuery: o }) => {
  const { data: n = [], isLoading: t } = o(), a = n, m = s((r2) => !Array.isArray(a) || (Array.isArray(r2) ? r2.every((r3) => a.includes(r3)) : a.includes(r2)), [a]);
  return t ? null : r(e.Provider, { value: { permissions: a, hasPermission: m }, children: i2 });
};
export {
  i as PermissionsProvider
};
//# sourceMappingURL=PermissionsProvider.js.map
